import { cn } from '@/lib/cn'

export type JarvisStatus = 'idle' | 'listening' | 'thinking' | 'on_call'

interface StatusPillProps {
  status: JarvisStatus
}

const labels: Record<JarvisStatus, string> = {
  idle: 'Idle',
  listening: 'Listening',
  thinking: 'Thinking',
  on_call: 'On a call',
}

const colorByStatus: Record<JarvisStatus, string> = {
  idle: 'text-jarvis-muted bg-jarvis-muted/10',
  listening: 'text-jarvis-blue bg-jarvis-blue/10',
  thinking: 'text-jarvis-cyan bg-jarvis-cyan/10',
  on_call: 'text-jarvis-green bg-jarvis-green/10',
}

const dotByStatus: Record<JarvisStatus, string> = {
  idle: 'bg-jarvis-muted',
  listening: 'bg-jarvis-blue',
  thinking: 'bg-jarvis-cyan',
  on_call: 'bg-jarvis-green',
}

export function StatusPill({ status }: StatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium border border-jarvis-border',
        colorByStatus[status],
      )}
    >
      <span
        className={cn(
          'inline-block w-1.5 h-1.5 rounded-full',
          dotByStatus[status],
          status !== 'idle' && 'animate-status-pulse',
        )}
      />
      {labels[status]}
    </span>
  )
}
